"use client";
import React from "react";
import { cn } from '@/lib/utils';

const ImageGallery = (candidate) => {
  candidate = candidate.candidate;
  const showBadgeScore = candidate.details?.coding_score || false;
  const showBadgeFirstTimePassed = showBadgeScore && (candidate.details?.is_first_time_passed || false);
  const showBadgeReadability = showBadgeScore && (candidate.details?.readability_score || false);
  const showBadgeEfficiency = showBadgeScore && (candidate.details?.badge_awarded || false);
  const showAllBadges = showBadgeScore && showBadgeFirstTimePassed && showBadgeReadability && showBadgeEfficiency;

  return (
    <div className="flex flex-wrap gap-4 justify-center items-center">
      {showBadgeScore && (
        <img
          className="w-20 h-20 object-contain"
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/a8715c22e160e8286709c0c041998230d13c1d5c49146dad1d43f44f96069c44?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
          alt="Gallery item 1"
        />
      )}
      {showBadgeEfficiency && (
        <img
          className="w-20 h-20 object-contain"
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/6fdc7beb9406310eb4756b3ed7dca5b6104d9c01e75295d051180eb0bf3cf13f?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
          alt="Gallery item 2"
        />
      )}
      {showBadgeFirstTimePassed && (
        <img
          className="w-20 h-20 object-contain"
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/069ed114d631d311cd3820ea9cb01906c82c2b680679d3891a7d51baa771850e?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
          alt="Gallery item 3"
        />
      )}
      {showBadgeReadability && (
        <img
          className="w-20 h-20 object-contain"
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/944dfff6c0c7752e8f6549ff01e9eadb3ee2478eb21481c428aacd6246f7c315?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
          alt="Gallery item 4"
        />
      )}
      {showAllBadges && (
        <img
          className="w-20 h-20 object-contain"
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/c09515fae4499310ff0d33d6d068471ed3d12165bbcb4f32ce214ff8511dc64c?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
          alt="Gallery item 5"
        />
      )}
    </div>
  );
};

export default ImageGallery;
